// extracted by mini-css-extract-plugin
export default {"wrapper-opened":"nH6hK","overlay":"TLv0o","overlay-opened":"KnZM9","replaceBlock":"MNp1p","replaceBlock-show":"haQ1o"};